import { IAuth } from '../../../ts/interface/admins.interface';
import {
  clearSystemData,
  setNewSystem,
  systemLoaded,
} from '../../../actionCreators/system';
import { connect } from 'react-redux';
import { useOrganizationStore } from '../../../store/organizationStore';
import { history } from '../../../utils';
import CustomToast from '../../../components/Redesing/custom-toast';
import { Link } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import { PropertyListItem } from '../../../components/Redesing/property-list-item';
import { validate as isUUID } from 'uuid';

// Move object outside component to prevent recreation
const emptyOrgInfo = {
  id: null,
  name: null,
  access: 0,
  parent_organization: null,
  config: null,
};

function ChangeOrganizationToSystem({
  system,
  auth,
  loaded,
  updateSystem,
  clearSystemData,
}: {
  system: {
    id: string;
    gid?: string;
    name: string;
  };
  auth: IAuth;
  loaded: (isLoaded: boolean) => void;
  updateSystem: (id: string, auth: IAuth) => Promise<void>;
  clearSystemData: () => void;
}) {
  const handleChangeSystem = () => {
    loaded(false);
    clearSystemData();
    const setOrganizationInfo = useOrganizationStore.getState().setOrganizationInfo;

    // validate if system.id is a UUID if not use system.gid
    const systemId = isUUID(system.id) ? system.id : system.gid;

    updateSystem(systemId ?? '', auth)
      .then(() => {
        loaded(true);
        setOrganizationInfo(emptyOrgInfo);
        localStorage.removeItem('organizationId');
        // carry the system in the URL so the destination is unambiguous
        // even if a stale organizationId param is still around
        history.push(`/dashboard?systemId=${systemId}`);
      })
      .catch((e: Error) => {
        CustomToast({
          type: 'error',
          message: `There was an error while changing systems: ${e.message}`,
        });
      });
  };

  return (
    <>
      <PropertyListItem
        label={'System'}
        value={
          <Link
            onClick={handleChangeSystem}
            data-id={`system-link`}
            to={`/dashboard?systemId=${system.id}`}
          >
            <Typography color="text.secondary" variant="subtitle1">
              {system.name}
              <i id="table_item_carot" className="fa fa-caret-right" />
            </Typography>
          </Link>
        }
      />
    </>
  );
}

export default connect(
  (state: { admin: { admin: IAuth } }) => ({
    auth: state.admin.admin,
  }),
  {
    clearSystemData,
    updateSystem: (systemId: string, auth: IAuth) => setNewSystem(systemId, auth),
    loaded: (bool: boolean) => systemLoaded(bool),
  }
)(ChangeOrganizationToSystem);
